import { ReduxThunkType } from '../../types/ReduxThunkType';
import { Actions as UserActions } from './actions';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import UserService from '../../services/UsersService';
import { ExternalUserProfileDetails, InternalUserFilter } from './types';
import { UserRoleType } from '../user/types';

export const getInternalUsers =
  (filter: InternalUserFilter): ReduxThunkType<void> =>
  async (dispatch) => {
    try {
      dispatch(UserActions.getInternalUsers());
      const result = await UserService.getInternalUsers(filter);
      dispatch(UserActions.getInternalUsersSuccess(result.data.content));
    } catch (error) {
      dispatch(UserActions.getInternalUsersError(error as RestErrorResponse));
    }
  };

export const getExternalUsers = (): ReduxThunkType<void> => async (dispatch) => {
  try {
    dispatch(UserActions.getExternalUsers());
    const result = await UserService.getExternalUsers();
    dispatch(UserActions.getExternalUsersSuccess(result.data.content));
  } catch (error) {
    dispatch(UserActions.getExternalUsersError(error as RestErrorResponse));
  }
};

export const updateInternalUserRole =
  (userId: number, role: UserRoleType): ReduxThunkType<void> =>
  async (dispatch) => {
    try {
      dispatch(UserActions.updateInternalUserRole());
      await UserService.updateInternalUserRole(userId, role);
      dispatch(UserActions.updateInternalUserRoleSuccess());
    } catch (error) {
      dispatch(UserActions.updateInternalUserRoleError(error as RestErrorResponse));
    }
  };

export const getExternalUserProfileDetails =
  (id: number): ReduxThunkType<void> =>
  async (dispatch) => {
    try {
      dispatch(UserActions.getExternalUserProfileDetails());
      const result = await UserService.getExternalUserProfileDetails(id);
      dispatch(UserActions.getExternalUserProfileDetailsSuccess(result.data.content));
    } catch (error) {
      dispatch(UserActions.getExternalUserProfileDetailsError(error as RestErrorResponse));
    }
  };

export const updateExternalUserProfileDetails =
  (id: number, data: ExternalUserProfileDetails): ReduxThunkType<void> =>
  async (dispatch) => {
    try {
      dispatch(UserActions.updateExternalUserProfileDetails());
      await UserService.updateExternalUserProfileDetails(id, data);
      dispatch(UserActions.updateExternalUserProfileDetailsSuccess());
    } catch (error) {
      dispatch(UserActions.updateExternalUserProfileDetailsError(error as RestErrorResponse));
    }
  };
